import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const CardsWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 72px 0 160px;
  padding: 0 20px;
  
  ${mediaQuery.maxWidth.tablet} {
    margin: 32 0 112px;
  }

  ${mediaQuery.maxWidth.phone} {
    justify-content: start;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
    cursor: grab;

    &::-webkit-scrollbar {
    display: none;
  }
  }
`;